module.exports = __webpack_public_path__ + "media/images/icon_nega0-757b1f713c9e31e5b679cf88dc74b30e.svg";